// @flow

import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAIL,
  SIGN_OUT,
  LOGIN,
  ERROR,
  REMEMBER,
  PASSWORD,
  CHOSE_PROJECT,
  CHOSE_PROJECT_SUCCESS,
  CHOSE_PROJECT_FAIL,    
  REGISTER_GUEST,
  REGISTER_GUEST_SUCCESS,
  REGISTER_GUEST_FAIL,
  CLEAR_MESSAGE,
  CLEAR_PROJECT,
  INITIAL_PASSWORD_CHANGED,
  SET_PROJECT
} from './../types/auth';

import type { AuthAction } from './../types/auth';

export const clearMessage = () => ({
  type: CLEAR_MESSAGE
});

export const signIn = (login: string, password: string, remember: boolean): AuthAction => ({
  type: SIGN_IN,
  [LOGIN]: login,
  [REMEMBER]: remember,
  [PASSWORD]: password,
});

export const choseProject = (project: Object, axiosInstance: Object) => ({
  type: CHOSE_PROJECT,
  axiosInstance: axiosInstance,
  project: project,
});

export const choseProjectSuccess = (project: Object, axiosIntance: Object, token: string) => ({
  type: CHOSE_PROJECT_SUCCESS,
  project: project,
  axiosInstance: axiosIntance,
  token: token,
});

export const choseProjectFail = (error: string) => ({
  type: CHOSE_PROJECT_FAIL,
  [ERROR]: error
});

export const setProject = (project: Object) => ({
    type: SET_PROJECT,
    project: project
});

export const clearProject = () => ({
  type: CLEAR_PROJECT,
});

export const signInSuccess = (userData: Object, axiosInstance: Object, token: string): AuthAction => ({
  type: SIGN_IN_SUCCESS,
  userData: userData,
  axiosInstance: axiosInstance,
  token: token,
});

export const signInFail = (error: string): AuthAction => ({
  type: SIGN_IN_FAIL,
  [ERROR]: error,
});

export const signOut = (): AuthAction => ({
  type: SIGN_OUT,
});

export const initialPasswordChanged = (): AuthAction => ({
  type: INITIAL_PASSWORD_CHANGED
});

export const registerGuest = (
  axiosInstance: Object,
  userData: {
    login: string,
    password: string,
    forename: string,
    surname: string,
    customerName: string,
    phoneNumber: string
  },
  recaptchaResponse: string,
): AuthAction => ({
  type: REGISTER_GUEST,
  axiosInstance,
  userData,
  recaptchaResponse,
});

export const registerGuestSuccess = (login: string): AuthAction => ({
  type: REGISTER_GUEST_SUCCESS,
  login
});

export const registerGuestFail = (error: string): AuthAction => ({
  type: REGISTER_GUEST_FAIL,
  [ERROR]: error
});


// WEBPACK FOOTER //
// ./src/actions/auth.jsx